import React from "react";
import { MenuItem } from "@mui/material";
import MuSelect, { SelectProps as MuSelectProps } from "@mui/material/Select";
import { ExpandMore } from "@mui/icons-material";

export type SelectProps = MuSelectProps & {};

const Select = ({ children, ...others }: SelectProps) => {
  return (
    <MuSelect
      IconComponent={ExpandMore}
      {...others}
      MenuProps={{
        PaperProps: {
          ...others?.MenuProps?.PaperProps,
          sx: {
            borderRadius: "8px!important",
            "& .MuiList-root": {
              borderRadius: "8px!important",
              border: "0!important",
            },
            "& .MuiButtonBase-root": {
              border: "0!important",
              fontWeight: 400,
            },
            "& .MuiMenuItem-root": {
              border: "0!important",
              fontWeight: 400,
            },
          },
        },
      }}>
      {children}
    </MuSelect>
  );
};

Select.MenuItem = MenuItem;
export default Select;
